import * as React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import * as moment from 'moment';
type Props = {
	field: FieldDto;
	value: string;
	changes: Partial<EntryDto>;
	setChanges: (changes: Partial<EntryDto>) => void;
};
const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		underline: {
			'&:before': {
				borderBottomColor: '#3f51b5',
			},
		},
		label: {
			color: '#858585',
		},
		labelUnsaved: {
			color: '#3f51b5',
			fontWeight: 600,
		},
		noValue: {
			color: '#cccccc',
		},
	})
);

const DateTimeField: React.FunctionComponent<Props> = (props) => {
	const classes = useStyles();

	const { value, field, setChanges, changes } = props;

	const val = moment.utc(value);

	return (
		<TextField
			autoComplete='off'
			type='datetime-local'
			fullWidth={true}
			disabled={field.Disabled}
			label={field.Legend}
			value={
				(val && val.isValid() && val.format(moment.HTML5_FMT.DATETIME_LOCAL)) ||
				undefined
			}
			onChange={(e) =>
				setChanges({ ...changes, [field.PropertyName]: e.target.value })
			}
			InputProps={{
				classes: {
					root: ((!value || !val.isValid()) && classes.noValue) || undefined,
					underline:
						(changes[field.PropertyName] && classes!.underline) || undefined,
				},
			}}
			InputLabelProps={{
				shrink: true,
				classes: {
					root:
						(changes[field.PropertyName] && classes!.labelUnsaved) ||
						classes!.label,
				},
			}}
		/>
	);
};

export default DateTimeField;
